import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import usePDPFullScreenClickEvent from 'data-hooks/useEvents/usePDPFullScreenClickEvent';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useUpholsteryFilteredEvent from 'data-hooks/useEvents/useUpholsteryFilteredEvent';
import usePDPPrice from 'data-hooks/usePDPPrice';
import useFabricFavs from 'data-hooks/useFabricFavs';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSelectUpholsteryUI from './PDPSelectUpholsteryUI';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPSelectUpholsteryPlaceholder from './PDPSelectUpholsteryPlaceholder';
const PDPSelectUpholsteryInner = t0 => {
  const $ = _c(51);
  const {
    isEditOrder: t1,
    mode: t2,
    onMoreMaterialsClick,
    optionsLoading,
    productId: t3,
    slug,
    setMarxentSelectedFabric,
    isLayoutRevamp: t4
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  const productId = t3 === undefined ? null : t3;
  const isLayoutRevamp = t4 === undefined ? false : t4;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: priceData
  } = usePDPPrice(productId, slug);
  const {
    loading,
    error,
    data: optionData,
    actions: t5
  } = usePDPOptions();
  const {
    onOptionValueHover,
    onOptionValueSelection
  } = t5;
  const {
    data: t6,
    actions: t7
  } = usePDPFabricFilters(slug, isEditOrder);
  const {
    activeColorFilters,
    activeNamedFilters,
    allMaterials,
    allMaterialsLength,
    disabledMaterialIds,
    favMaterials,
    filterCounts,
    filteredMaterials,
    flashSaleOptionIds,
    isClearanceFabricAvailable,
    isSelectedOptionsQuickship,
    optionName,
    selectedMaterial,
    selectedOptionsStockQty,
    upholsteryOptionId
  } = t6;
  const {
    clearAllFilters,
    toggleNamedFilter,
    toggleColorFilter
  } = t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      loadMaterialDetails: true
    };
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  const {
    actions: t9
  } = useFabricFavs(t8);
  let t10;
  if ($[1] !== t9) {
    t10 = t9 === undefined ? {} : t9;
    $[1] = t9;
    $[2] = t10;
  } else {
    t10 = $[2];
  }
  const {
    setOptionAsFav,
    removeOptionAsFav
  } = t10;
  let t11;
  if ($[3] !== selectedMaterial || $[4] !== setMarxentSelectedFabric) {
    t11 = () => {
      if (selectedMaterial?.sku) {
        setMarxentSelectedFabric?.(selectedMaterial.sku.replace("-", ""));
      }
    };
    $[3] = selectedMaterial;
    $[4] = setMarxentSelectedFabric;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const t12 = selectedMaterial?.sku;
  let t13;
  if ($[6] !== setMarxentSelectedFabric || $[7] !== t12) {
    t13 = [t12, setMarxentSelectedFabric];
    $[6] = setMarxentSelectedFabric;
    $[7] = t12;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  useEffect(t11, t13);
  const {
    fullScreenClickEvent
  } = usePDPFullScreenClickEvent(basicDetails, optionData, priceData);
  const {
    upholsteryFilteredEvent
  } = useUpholsteryFilteredEvent(basicDetails, optionData, priceData, "PDP");
  basicDetails?.id;
  basicDetails?.name;
  basicDetails?.type.name;
  let t14;
  if ($[9] !== removeOptionAsFav || $[10] !== setOptionAsFav) {
    t14 = {
      setOptionAsFav,
      removeOptionAsFav
    };
    $[9] = removeOptionAsFav;
    $[10] = setOptionAsFav;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const t15 = basicDetails?.name;
  const t16 = basicDetails?.id;
  const t17 = basicDetails?.type.name;
  let t18;
  if ($[12] !== t15 || $[13] !== t16 || $[14] !== t17) {
    t18 = {
      name: t15,
      productId: t16,
      category: t17
    };
    $[12] = t15;
    $[13] = t16;
    $[14] = t17;
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  const t19 = allMaterials?.[0];
  let t20;
  if ($[16] !== favMaterials || $[17] !== t18 || $[18] !== t19) {
    t20 = {
      favMaterials,
      favProductData: t18,
      defaultToMaterial: t19
    };
    $[16] = favMaterials;
    $[17] = t18;
    $[18] = t19;
    $[19] = t20;
  } else {
    t20 = $[19];
  }
  let t21;
  if ($[20] !== t14 || $[21] !== t20) {
    t21 = {
      actions: t14,
      data: t20
    };
    $[20] = t14;
    $[21] = t20;
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  const fabricFavProps = t21;
  if (error) {
    return null;
  }
  const t22 = loading || optionsLoading;
  let t23;
  if ($[23] !== activeColorFilters || $[24] !== activeNamedFilters || $[25] !== allMaterialsLength || $[26] !== clearAllFilters || $[27] !== disabledMaterialIds || $[28] !== fabricFavProps || $[29] !== filterCounts || $[30] !== filteredMaterials || $[31] !== flashSaleOptionIds || $[32] !== fullScreenClickEvent || $[33] !== isClearanceFabricAvailable || $[34] !== isEditOrder || $[35] !== isLayoutRevamp || $[36] !== isSelectedOptionsQuickship || $[37] !== mode || $[38] !== onMoreMaterialsClick || $[39] !== onOptionValueHover || $[40] !== onOptionValueSelection || $[41] !== optionName || $[42] !== selectedMaterial || $[43] !== selectedOptionsStockQty || $[44] !== slug || $[45] !== t22 || $[46] !== toggleColorFilter || $[47] !== toggleNamedFilter || $[48] !== upholsteryFilteredEvent || $[49] !== upholsteryOptionId) {
    t23 = <PDPSelectUpholsteryUI activeColorFilters={activeColorFilters} activeNamedFilters={activeNamedFilters} allMaterialsLength={allMaterialsLength} clearAllFilters={clearAllFilters} disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} filterCounts={filterCounts} flashSaleOptionIds={flashSaleOptionIds} fullScreenClickEvent={fullScreenClickEvent} isClearanceFabricAvailable={isClearanceFabricAvailable} isEditOrder={isEditOrder} isSelectedOptionsQuickship={isSelectedOptionsQuickship} loading={t22} materials={filteredMaterials} mode={mode} onMoreMaterialsClick={onMoreMaterialsClick} onOptionValueHover={onOptionValueHover} onOptionValueSelection={onOptionValueSelection} selectedMaterial={selectedMaterial} selectedOptionsStockQty={selectedOptionsStockQty} slug={slug} toggleColorFilter={toggleColorFilter} toggleNamedFilter={toggleNamedFilter} upholsteryFilteredEvent={upholsteryFilteredEvent} upholsteryOptionId={upholsteryOptionId} upholsteryOptionName={optionName} isLayoutRevamp={isLayoutRevamp} />;
    $[23] = activeColorFilters;
    $[24] = activeNamedFilters;
    $[25] = allMaterialsLength;
    $[26] = clearAllFilters;
    $[27] = disabledMaterialIds;
    $[28] = fabricFavProps;
    $[29] = filterCounts;
    $[30] = filteredMaterials;
    $[31] = flashSaleOptionIds;
    $[32] = fullScreenClickEvent;
    $[33] = isClearanceFabricAvailable;
    $[34] = isEditOrder;
    $[35] = isLayoutRevamp;
    $[36] = isSelectedOptionsQuickship;
    $[37] = mode;
    $[38] = onMoreMaterialsClick;
    $[39] = onOptionValueHover;
    $[40] = onOptionValueSelection;
    $[41] = optionName;
    $[42] = selectedMaterial;
    $[43] = selectedOptionsStockQty;
    $[44] = slug;
    $[45] = t22;
    $[46] = toggleColorFilter;
    $[47] = toggleNamedFilter;
    $[48] = upholsteryFilteredEvent;
    $[49] = upholsteryOptionId;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
};
PDPSelectUpholsteryInner.propTypes = {
  isEditOrder: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  optionsLoading: PropTypes.bool,
  productId: PropTypes.number,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string,
  isLayoutRevamp: PropTypes.bool
};
const PDPSelectUpholstery = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPSelectUpholsteryPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPSelectUpholsteryInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPSelectUpholstery;